import styled, { css } from 'styled-components'

import type { FormLabelProps } from './index'

export const Label = styled.label<
  { $error?: boolean; $variant: FormLabelProps['variant'] } & Omit<FormLabelProps, 'error'>
>`
  display: inline-block;
  color: ${(props) =>
    props.$variant === 'black' ? props.theme.colors.nightRider : props.theme.colors.neonBlue};
  ${(props) => props.theme.textStyles.text};

  &[required]:after {
    content: ' *';
    color: ${(props) =>
      props.$variant === 'black' ? props.theme.colors.royalBlue : props.theme.colors.darkOrange};
  }

  ${(props) =>
    props.$error &&
    css`
      color: ${(props) => props.theme.colors.red};
    `}
`
